export default "__VITE_ASSET__DLzvRpql__"